var _g, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61436_41349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7777 18.666H17.2222C16.4855 18.666 15.7789 18.3851 15.258 17.885C14.7371 17.3849 14.4444 16.7066 14.4444 15.9993C14.4444 15.2921 14.7371 14.6138 15.258 14.1137C15.7789 13.6136 16.4855 13.3327 17.2222 13.3327H24.1666C24.535 13.3327 24.8883 13.4732 25.1487 13.7232C25.4092 13.9733 25.5555 14.3124 25.5555 14.666C25.5555 15.0196 25.7018 15.3588 25.9623 15.6088C26.2228 15.8589 26.576 15.9993 26.9444 15.9993C27.3128 15.9993 27.666 15.8589 27.9265 15.6088C28.187 15.3588 28.3333 15.0196 28.3333 14.666C28.3333 13.6051 27.8943 12.5877 27.1129 11.8376C26.3315 11.0874 25.2717 10.666 24.1666 10.666H21.3888V7.99935C21.3888 7.64573 21.2425 7.30659 20.9821 7.05654C20.7216 6.80649 20.3683 6.66602 20 6.66602C19.6316 6.66602 19.2783 6.80649 19.0179 7.05654C18.7574 7.30659 18.6111 7.64573 18.6111 7.99935V10.666H17.2222C15.7488 10.666 14.3357 11.2279 13.2938 12.2281C12.2519 13.2283 11.6666 14.5849 11.6666 15.9993C11.6666 17.4138 12.2519 18.7704 13.2938 19.7706C14.3357 20.7708 15.7488 21.3327 17.2222 21.3327H22.7777C23.5145 21.3327 24.221 21.6136 24.7419 22.1137C25.2629 22.6138 25.5555 23.2921 25.5555 23.9993C25.5555 24.7066 25.2629 25.3849 24.7419 25.885C24.221 26.3851 23.5145 26.666 22.7777 26.666H15.8333C15.4649 26.666 15.1117 26.5255 14.8512 26.2755C14.5907 26.0254 14.4444 25.6863 14.4444 25.3327C14.4444 24.9791 14.2981 24.6399 14.0376 24.3899C13.7771 24.1398 13.4239 23.9993 13.0555 23.9993C12.6872 23.9993 12.3339 24.1398 12.0734 24.3899C11.813 24.6399 11.6666 24.9791 11.6666 25.3327C11.6666 26.3935 12.1056 27.411 12.887 28.1611C13.6684 28.9113 14.7282 29.3327 15.8333 29.3327H18.6111V31.9993C18.6111 32.353 18.7574 32.6921 19.0179 32.9422C19.2783 33.1922 19.6316 33.3327 20 33.3327C20.3683 33.3327 20.7216 33.1922 20.9821 32.9422C21.2425 32.6921 21.3888 32.353 21.3888 31.9993V29.3327H22.7777C24.2512 29.3327 25.6642 28.7708 26.7061 27.7706C27.748 26.7704 28.3333 25.4138 28.3333 23.9993C28.3333 22.5849 27.748 21.2283 26.7061 20.2281C25.6642 19.2279 24.2512 18.666 22.7777 18.666Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint0_linear_61436_41349)",
    strokeOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint1_linear_61436_41349)",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61436_41349",
    x1: 40,
    y1: 40,
    x2: 23.4306,
    y2: -8.07545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61436_41349",
    x1: 40,
    y1: 0,
    x2: -8.12808,
    y2: 22.9683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61436_41349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.129b6dd567587c0d07ce61048e405367.svg";
export { ForwardRef as ReactComponent };